import { AxiosResponse } from 'axios';
import { api } from 'services/companiesApi';

export const postPresignedUrl = async (
	jobRiskId: string,
	fileName: string,
): Promise<AxiosResponse> => {
	return await api.post(`/job-risks/factors/${jobRiskId}`, {
		fileName: fileName,
	});
};
